import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import Animation from '../Animation';
import InputBase from '../form/InputBase';
import styled from 'styled-components/macro';
import Colors from '../../internal-components/Colors';
import useTranslations from '../../hooks/useTranslations';

const FromEmailContainer = styled.div`
  display: flex;
  align-items: center;
  span {
    margin-left: 0.8rem;
    flex: 1;
  }
`;
const Error = styled.small`
  color: ${Colors.OT_RED};
`;

const FormBuilderShareEmailSettingsView = props => {
  const t = useTranslations();

  return (
    <>
      <Tooltip
        arrow
        title={
          props.isEmailFromReadOnly
            ? 'Contact support@vinciworks.com to enable custom sender address'
            : ''
        }
      >
        <FromEmailContainer>
          <InputBase
            variant="outlined"
            value={props.fromEmailAddress}
            onChange={e => props.setFromEmailAddress(e.target.value)}
            onBlur={props.onEmailSenderInputBlur}
            onFocus={() => props.setIsEmailFromOk(true)}
            error={!props.isEmailFromOk}
            disabled={
              props.isEmailFromReadOnly &&
              process.env.REACT_APP_S3_ENV.toLowerCase() !== 'development'
            }
            customCSS="width: 30% !important;"
          />
          <span>@{props.fromEmailAddressDomain}</span>
        </FromEmailContainer>
      </Tooltip>
      <Animation in={!props.isEmailFromOk} type="fade">
        <Error>{t('form-builder.users.email_settings.error')}</Error>
      </Animation>
    </>
  );
};

export default FormBuilderShareEmailSettingsView;
